import { QuotationCoverage } from 'data-layer-cr/dist/models';
import { moneyFormat } from 'design-system';
import { ExemptionCoverageId } from 'src/components/screens/Quotations/components/IndividualCoverages/ExemptionCoverage';
import { getTypeOfQuotation, typeOfQuotation } from './individualOptionHelpers';

const { formatMoney } = moneyFormat;
const coveragesCodes = ['0004', '0005'];

export const replaceCoverageValues = (
  originalCoverages: QuotationCoverage[],
  modifiedCoverages: QuotationCoverage[],
): QuotationCoverage[] => {
  return originalCoverages.map((coverage): QuotationCoverage => {
    const changedCoverage = modifiedCoverages.find(
      (covItem) => covItem.coverageId === coverage.coverageId,
    );
    if (changedCoverage) {
      return { ...coverage, insuredValue: changedCoverage.insuredValue };
    }
    return coverage;
  });
};

export const getDeductibleDefaultBase = (
  packageOption: number,
  coverageId: string,
  createdAt?: string,
): string => {
  const quotationType = getTypeOfQuotation(createdAt);
  const coverages =
    typeOfQuotation[quotationType].packageOptions?.[packageOption];
  if (coverageId === ExemptionCoverageId) return 'D';
  if (!coverages) return 'M';
  if (coverages.includes(coverageId)) return 'P';
  return 'M';
};

export const getDeductibleDisplayText = (
  deductibleType: string,
  value: number,
  percentage: number,
  moneyType: string | undefined,
  coverageId: string,
  packageOption: number,
  createdAt: string,
): string => {
  const quotationType = getTypeOfQuotation(createdAt);
  const coverages =
    typeOfQuotation[quotationType].packageOptions?.[packageOption];
  const deductibleText = coverages?.includes(coverageId)
    ? ' de la pérdida'
    : '';
  if (deductibleType === 'P') {
    return `${percentage}%${deductibleText}`;
  }
  return formatMoney(value, false, moneyType);
};

export const getDeductibleHelperText = (
  deductibleType: string,
  value: number,
  moneyType: string | undefined,
): string => {
  if (deductibleType === 'M') {
    return `Fijos por evento`;
  }
  return `Con mínimo de ${formatMoney(value, false, moneyType)}`;
};

export const getDeductibleRate = (
  coverageId: string,
  deductibleOption: number,
): number => {
  if (coveragesCodes.includes(coverageId)) {
    if (deductibleOption === 1) {
      return 15;
    }
    if (deductibleOption === 2) {
      return 20;
    }
    return 30;
  }
  return 0;
};

const getDeductibleValueForDollar = (
  coverageId: string,
  deductibleOption: number,
): number => {
  if (coveragesCodes.includes(coverageId)) {
    return 250;
  }
  if (coverageId !== '0002') {
    return 0;
  }
  if (deductibleOption === 1) {
    return 300;
  }
  if (deductibleOption === 2) {
    return 600;
  }
  return 1000;
};

const getDeductibleValueForColons = (
  coverageId: string,
  deductibleOption: number,
): number => {
  if (coveragesCodes.includes(coverageId)) {
    return 125_000;
  }
  if (coverageId !== '0002') {
    return 0;
  }
  if (deductibleOption === 1) {
    return 150_000;
  }
  if (deductibleOption === 2) {
    return 300_000;
  }
  return 500_000;
};

export const getDeductibleValue = (
  coverageId: string,
  deductibleOption: number,
  moneyType: string,
): number => {
  return moneyType === '$'
    ? getDeductibleValueForDollar(coverageId, deductibleOption)
    : getDeductibleValueForColons(coverageId, deductibleOption);
};

export const changeCoverageDeductible = (
  coverages: QuotationCoverage[],
  deductibleOption: number,
  moneyType = '$',
): QuotationCoverage[] => {
  return coverages.map((coverage): QuotationCoverage => {
    const { coverageId } = coverage;
    return {
      ...coverage,
      deductibleRate: getDeductibleRate(coverageId, deductibleOption),
      deductible: getDeductibleValue(coverageId, deductibleOption, moneyType),
    };
  });
};

export default replaceCoverageValues;
